__turbopack_context__.v({
  "active": "AddToPreferences-module-scss-module__f7QKLG__active",
  "icon": "AddToPreferences-module-scss-module__f7QKLG__icon",
  "path": "AddToPreferences-module-scss-module__f7QKLG__path",
});
